import * as WKT from "terraformer-wkt-parser";
import * as ArcGIS from "terraformer-arcgis-parser";
export class WktConverterUtils {
    static ConvertWktToArcGisJson(wkt, wkidSpatialReference) {
        try {
            // convert wkt to geojson
            const geojson = this.ConvertWktToGeoJson(wkt);
            // convert a GeoJSON object into an ArcGIS geometry
            const parseOptions = {
                sr: wkidSpatialReference
            };
            const arcgisGeometry = this.ConvertGeoJsonToArcGis(geojson, parseOptions);
            return arcgisGeometry;
        }
        catch (e) {
            throw Error("ConvertWktToArcGisJson: " + e);
        }
    }
    static ConvertGeoJsonToArcGis(geojson, parseOptions) {
        try {
            return ArcGIS.convert(geojson, parseOptions);
        }
        catch (e) {
            throw Error("ConvertGeoJsonToArcGis: " + e);
        }
    }
    static ConvertWktToGeoJson(wkt) {
        try {
            return WKT.parse(wkt);
        }
        catch (e) {
            throw Error("ConvertWktToGeoJson: " + e);
        }
    }
    static ConvertArcGISJsonToWkt(arcgisJson) {
        try {
            // convert ArcGIS geometry to GeoJSON
            const geojson = this.ConvertArcGisToGeoJson(arcgisJson);
            // convert ArcGIS geometry to GeoJSON
            const wkt = this.ConvertGeoJsonToWkt(geojson);
            return wkt;
        }
        catch (e) {
            throw Error("ConvertWktToArcGisJson: " + e);
        }
    }
    static ConvertArcGisToGeoJson(arcgisJson) {
        try {
            return ArcGIS.parse(arcgisJson);
        }
        catch (e) {
            throw Error("ConvertGeoJsonToArcGis: " + e);
        }
    }
    static ConvertGeoJsonToWkt(geojson) {
        try {
            return WKT.convert(geojson);
        }
        catch (e) {
            throw Error("ConvertWktToGeoJson: " + e);
        }
    }
    static testPerformanceLoop() {
        const wkt = "MULTIPOLYGON (((40 40, 20 45, 45 30, 40 40)), ((20 35, 45 20, 30 5, 10 10, 10 30, 20 35), (30 20, 20 25, 20 15, 30 20)))";
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < 500; ++i) {
            this.ConvertWktToArcGisJson(wkt, 3857);
        }
    }
}
